import { useMediaQuery } from '@material-ui/core';
import { CustomTheme } from '@nemuru-eng/js-api-client';
import { generatePath } from 'react-router-dom';

import { channelAgentNameFieldColumn } from '@/components/modules/_shared/utils/DataGridFields/channelAgentNameFieldColumn';
import { lenderLogoFieldColumn } from '@/components/modules/_shared/utils/DataGridFields/lenderLogoFieldColumn';
import { toDealDetailFieldColumn } from '@/components/modules/_shared/utils/DataGridFields/toDealDetailFieldColumn';
import { updatedAtFieldColumn } from '@/components/modules/_shared/utils/DataGridFields/updatedAtFieldColumn';
import { referenceFieldColumn } from '@/components/modules/AutoLoanList/utils/AutoLoanDataGridFields/components/referenceFieldColumn';
import { reportingStatusFieldColumn } from '@/components/modules/AutoLoanList/utils/AutoLoanDataGridFields/components/reportingStatusFieldColumn';
import { scheduledDeliveryDateFieldColumn } from '@/components/modules/AutoLoanList/utils/AutoLoanDataGridFields/components/scheduledDeliveryDateFieldColumn';
import { vinFieldColumn } from '@/components/modules/AutoLoanList/utils/AutoLoanDataGridFields/components/vinFieldColumn';
import { assetTypeFieldColumn } from '@/components/modules/LoanListByProduct/utils/LoanDataGridFields/components/assetTypeFieldColumn';
import { borrowerNameFieldColumn } from '@/components/modules/LoanListByProduct/utils/LoanDataGridFields/components/borrowerNameFieldColumn';
import { principalFieldColumn } from '@/components/modules/LoanListByProduct/utils/LoanDataGridFields/components/principalFieldColumn';
import { statusWithPrincipalAmountMobile } from '@/components/modules/LoanListByProduct/utils/LoanDataGridFields/components/statusWithPrincipalAmountMobile';
import { updatedAtWithBorrowerNameFieldColumnMobile } from '@/components/modules/LoanListByProduct/utils/LoanDataGridFields/components/updatedAtWithBorrowerNameFieldColumnMobile';
import { DETAILS_PATH_BY_PRODUCT } from '@/config/config';
import { ApplicationType } from '@/config/types';
import { useCustomTheme } from '@/hooks/useCustomTheme';

interface AutoLoanDataGridFieldsProps {
  reducedWidth?: boolean;
}

export function AutoLoanDataGridFields({ reducedWidth = false }: AutoLoanDataGridFieldsProps) {
  const { breakpoints } = useCustomTheme();
  const { themeName } = useCustomTheme();
  const isThemeCaixaBank = themeName === CustomTheme.CAIXABANK;
  const isDownMd = useMediaQuery(breakpoints.down('md'));

  const targetPath = DETAILS_PATH_BY_PRODUCT[ApplicationType.AUTO];
  const linkTo = (id) => generatePath(targetPath, { loanId: id });

  const desktopFields = [
    assetTypeFieldColumn({ flex: 0.05 }),
    borrowerNameFieldColumn({ flex: reducedWidth ? 0.2 : 0.18 }),
    channelAgentNameFieldColumn({ flex: reducedWidth ? 0.18 : 0.18 }),
    referenceFieldColumn({ flex: reducedWidth ? 0.15 : 0.13 }),
    vinFieldColumn({ flex: reducedWidth ? 0.15 : 0.12 }),
    scheduledDeliveryDateFieldColumn({ flex: reducedWidth ? 0.12 : 0.13 }),
    ...(!isThemeCaixaBank ? [lenderLogoFieldColumn({ flex: reducedWidth ? 0.1 : 0.1 })] : []),
    principalFieldColumn({ flex: reducedWidth ? 0.12 : 0.12 }),
    updatedAtFieldColumn({ flex: reducedWidth ? 0.12 : 0.12 }),
    reportingStatusFieldColumn({ flex: reducedWidth ? 0.14 : 0.19 }),
    toDealDetailFieldColumn({ linkTo, flex: 0.05 }),
  ];

  const mobileFields = [
    updatedAtWithBorrowerNameFieldColumnMobile({ flex: 0.55 }),
    statusWithPrincipalAmountMobile({ flex: 0.45 }),
  ];

  return isDownMd ? mobileFields : desktopFields;
}
